// extracted by mini-css-extract-plugin
module.exports = {"genericButton":"ReportButton_genericButton__77Tbc","icon":"ReportButton_icon__38SA5","baseline":"ReportButton_baseline__19nsk","buttonText":"ReportButton_buttonText__3zE8E"};